import React from 'react'
import { Row, Col, Card, Statistic } from 'antd'
import { MedicineBoxOutlined, DollarOutlined, WarningOutlined, ShoppingOutlined } from '@ant-design/icons'
import { COLORS, STOCK_STATUS } from '../InventoryItems/utils/constants'
import { formatCurrency } from '../InventoryItems/utils/helpers'

const StatisticsCards = ({ stats }) => {
  return (
    <Row gutter={[16, 16]} className='stats-row'>
      <Col xs={24} sm={12} md={6}>
        <Card className='stat-card'>
          <MedicineBoxOutlined className='stat-icon' style={{ color: COLORS.PRIMARY }} />
          <Statistic title='Total Inventory Items' value={stats.totalItems} valueStyle={{ color: COLORS.PRIMARY }} />
        </Card>
      </Col>

      <Col xs={24} sm={12} md={6}>
        <Card className='stat-card'>
          <DollarOutlined className='stat-icon' style={{ color: COLORS.SUCCESS }} />
          <Statistic
            title='Total Inventory Value'
            value={formatCurrency(stats.totalValue)}
            valueStyle={{ color: COLORS.SUCCESS }}
          />
        </Card>
      </Col>

      <Col xs={24} sm={12} md={6}>
        <Card className='stat-card'>
          <WarningOutlined className='stat-icon' style={{ color: COLORS.WARNING }} />
          <Statistic
            title='Low Stock Items'
            value={stats.lowStockItems}
            valueStyle={{ color: COLORS.WARNING }}
            suffix={`/ ${stats.totalItems}`}
          />
        </Card>
      </Col>

      <Col xs={24} sm={12} md={6}>
        <Card className='stat-card'>
          <ShoppingOutlined className='stat-icon' style={{ color: COLORS.INFO }} />
          <Statistic
            title='Pending Orders Value'
            value={formatCurrency(stats.ordersValue)}
            valueStyle={{ color: COLORS.INFO }}
            suffix={<small>{stats.pendingOrders} orders</small>}
          />
        </Card>
      </Col>
    </Row>
  )
}

export default StatisticsCards
